export class OptimizeStatus {
  pageIsCached: boolean;
  pageIsOptimized: boolean;
  cachingDate: number;
}
